// src/pages/CuvriqVideoPage.jsx
import React from "react";

const BRAND_PRIMARY = "#0F172A"; // deep navy
const BRAND_ACCENT = "#06B6D4";  // teal
const BORDER = "#E5E7EB";
const BG = "#F8FAFC";

export default function CuvriqVideoPage() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: BG,
        padding: "40px 16px",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <style>{`
        .video-container {
          max-width: 960px;
          width: 100%;
          background: #ffffff;
          border-radius: 24px;
          padding: 32px 28px 32px;
          border: 1px solid ${BORDER};
          box-shadow: 0 16px 40px rgba(15,23,42,0.12);
        }
        @media (max-width: 640px) {
          .video-container {
            padding: 20px 18px 24px;
          }
        }
        .video-kicker {
          text-transform: uppercase;
          letter-spacing: 0.14em;
          font-weight: 700;
          font-size: 11px;
          color: ${BRAND_ACCENT};
          margin-bottom: 6px;
        }
        .video-title {
          font-size: 28px;
          line-height: 1.2;
          font-weight: 800;
          color: ${BRAND_PRIMARY};
          margin: 0 0 8px;
        }
        .video-sub {
          font-size: 15px;
          color: #4b5563;
          max-width: 620px;
          margin-bottom: 18px;
        }
        .video-ctas {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-bottom: 24px;
        }
        .video-btn {
          border-radius: 999px;
          padding: 9px 16px;
          font-size: 14px;
          font-weight: 600;
          border: 1px solid transparent;
          cursor: pointer;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
        }
        .video-btn-primary {
          background: ${BRAND_PRIMARY};
          color: #ffffff;
          border-color: ${BRAND_PRIMARY};
        }
        .video-btn-primary:hover {
          background: ${BRAND_ACCENT};
          border-color: ${BRAND_ACCENT};
        }
        .video-btn-outline {
          background: #ffffff;
          color: ${BRAND_PRIMARY};
          border-color: ${BORDER};
        }
        .video-btn-outline:hover {
          background: #f3f4f6;
        }
        .video-wrap {
          position: relative;
          width: 100%;
          border-radius: 20px;
          overflow: hidden;
          background: #020617;
          margin-bottom: 22px;
        }
        /* 16:9 responsive */
        .video-inner {
          position: relative;
          padding-bottom: 56.25%;
          height: 0;
        }
        .video-inner iframe {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border: 0;
        }
        .video-meta {
          display: grid;
          grid-template-columns: minmax(0, 2fr) minmax(0, 1.2fr);
          gap: 18px;
          margin-top: 4px;
        }
        @media (max-width: 768px) {
          .video-meta {
            grid-template-columns: 1fr;
          }
        }
        .video-card {
          background: #f9fafb;
          border-radius: 16px;
          padding: 14px 14px 12px;
          border: 1px solid ${BORDER};
          font-size: 14px;
          color: #4b5563;
        }
        .video-card h3 {
          font-size: 14px;
          font-weight: 700;
          margin: 0 0 6px;
          color: ${BRAND_PRIMARY};
        }
        .video-card ul {
          margin: 0;
          padding-left: 18px;
        }
        .video-card li {
          margin-bottom: 4px;
        }
      `}</style>

      <div className="video-container">
        <p className="video-kicker">CuvrIQ demo</p>
        <h1 className="video-title">See dashboard, upload page and best of all see how Riq answers coverage questions in real time.</h1>
        <p className="video-sub">
          In this quick walkthrough, you’ll see how CuvrIQ turns messy insurance benefits into clean, searchable coverage answers that anyone in your team can interact with
        </p>

        {/* CTAs */}
        <div className="video-ctas">
          <a href="/beta#apply" className="video-btn video-btn-primary">
            Request beta access
          </a>
          <a href="/beta" className="video-btn video-btn-outline">
            Back to beta overview
          </a>
        </div>

        {/* Video */}
        <div className="video-wrap">
          <div className="video-inner">
            {/* Replace with Loom or YouTube link */}
            <iframe
              src="https://youtube.com/embed/4J_gytNIR5c?rel=0"
              title="CuvrIQ Demo Video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>

        {/* Under-video highlights */}
        <div className="video-meta">
          <div className="video-card">
            <h3>What this demo covers</h3>
            <ul>
              <li> Uploading & parsing a real plan</li>
              <li> Verifying structured coverage</li>
              <li> Asking Riq real-world coverage questions</li>
              
            </ul>
          </div>

          <div className="video-card">
            <h3>Try it with your plans</h3>
            <p style={{ margin: 0 }}>
              Request beta access to upload your real benefit breakdowns and see how quickly Riq can answer questions for your team.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
